import React, { FC, useContext } from 'react';
import Button from '../CommonButton';
import styles from './index.module.scss';
import SideBarFootor from './SideBarFooter';
import { pagePathUrl } from '@/constants/url';
import userCenter from '@/constants/userCenter';
import useCheckLoginState from '@/hooks/useCheckLoginState';
import LoginTips, { LoginTipOption } from './LoginTips';
import SideItems, { HomeSidebarListOption } from './SideItems';
// import Home from '../../assets/icon/homeSidebar/home.svg';
// import HomeActive from '../../assets/icon/homeSidebar/homeActive.svg';
// import Points from '../../assets/icon/homeSidebar/points.svg';
import GitfIcon from '../../assets/icon/homeSidebar/gitf.svg';
// import Square from '../..//assets/icon/homeSidebar/square.svg';
// import SquareActive from '../..//assets/icon/homeSidebar/squareActive.svg';
// import Consult from '../..//assets/icon/homeSidebar/consult.svg';
// import ConsultActive from '../..//assets/icon/homeSidebar/consultActive.svg';
// import ActivityActive from '../..//assets/icon/homeSidebar/activityActive.svg';
// import Activity from '../..//assets/icon/homeSidebar/activity.svg';
import LoginIcon from '../..//assets/icon/homeSidebar/login.svg';
import MyPosts from '../../assets/icon/homeSidebar/my-posts.svg';
import AddPost from '../../assets/icon/homeSidebar/add-post.svg';
import DoubtsIcon from '../../assets/icon/homeSidebar/doubts.svg';
import Favorite from '../..//assets/icon/homeSidebar/favorite.svg';
import TutorialsIcon from '../../assets/icon/homeSidebar/tutorials.svg';
import Interaction from '../..//assets/icon/homeSidebar/interaction.svg';
import ReplyIcon from '../../assets/icon/comment.svg';
import Notifications from '../../assets/icon/homeSidebar/notifications.svg';
import { namespace, StoreContext } from '@/context';
import { PromiseState } from '@/constants';
import errorCode from '@/constants/errorCode';
import { useTranslations } from 'next-intl';
import Toast from '../Toast';
import LeftColumnSkeleton from '../Skeleton/SkeletonSidebar';
import { useGlobalContext } from '../ResponsiveLayout';


/** 登录提示卡片内容 */
const HOME_SIDEBAR_LOGIN_TIPS_OPTIONS: LoginTipOption[] = [
  {
    key: '1',
    icon: <TutorialsIcon />,
    label: '优选教程，带你玩出花样',
  },
  {
    key: '2',
    icon: <GitfIcon />,
    label: '积分奖励，周边礼品等你拿',
  },
  {
    key: '3',
    icon: <DoubtsIcon />,
    label: '答疑解惑，玩机不再困扰',
  },
  {
    key: '4',
    icon: <Interaction />,
    label: '与万千疆友一起同好交流',
  },
]

// 左侧导航组件
const Sidebar: FC = () => {
  const t = useTranslations();
  const { state } = useContext(StoreContext);
  const { permission, account, sensors } = state[namespace.app];
  const { track, TRACK_EVENTS } = sensors || {};
  const { isLogout, hadLoginState } = useCheckLoginState();

  const HOME_SIDEBAR_LIST_OPTIONS: HomeSidebarListOption[] = [
    {
      key: 'myPosts',
      label: '我的帖子',
      icon: {
        normal: <MyPosts />,
        active: <MyPosts />,
      },
      path: `/pro/user-center?do=thread&view=me&type=thread&from=space&uid=${account?.id}&uuid=${account?.uuid}`,
      onClick: () => {
        if (isLogout) {
          window.open(userCenter(`${process.env.SITE_ORIGIN}/pro/user-center?do=thread&view=me&type=thread&from=space`).login, '_blank');
          return;
        }
        window.open(`/pro/user-center?do=thread&view=me&type=thread&from=space&uid=${account?.id}&uuid=${account?.uuid}`, 'self');
      }
    },
    {
      key: 'myReplies',
      label: '我的评论',
      icon: {
        normal: <ReplyIcon width={28} height={28} />,
        active: <ReplyIcon width={28} height={28} />,
      },
      path: `/pro/user-center?do=reply&view=me&from=space&uid=${account?.id}&uuid=${account?.uuid}`,
      onClick: () => {
        if (isLogout) {
          window.open(userCenter(`${process.env.SITE_ORIGIN}/pro/user-center?do=reply&view=me&from=space`).login, '_blank');
          return;
        }
        window.open(`/pro/user-center?do=reply&view=me&from=space&uid=${account?.id}&uuid=${account?.uuid}`, 'self');
      }
    },
    {
      key: 'favorite',
      label: '我的收藏',
      icon: {
        normal: <Favorite />,
        active: <Favorite />,
      },
      path: `/pro/user-center?do=favorite&view=me&from=space&uid=${account?.id}&uuid=${account?.uuid}`,
      onClick: () => {
        if (isLogout) {
          window.open(userCenter(`${process.env.SITE_ORIGIN}/pro/user-center?do=favorite&view=me&from=space`).login, '_blank');
          return;
        }
        window.open(`/pro/user-center?do=favorite&view=me&from=space&uid=${account?.id}&uuid=${account?.uuid}`, 'self');
      }
    },
    {
      key: 'notifications',
      label: '消息',
      icon: {
        normal: <Notifications />,
        active: <Notifications />,
      },
      path: `/pro/user-center?do=mynotice&uid=${account?.id}&uuid=${account?.uuid}`,
      onClick: () => {
        if (isLogout) {
          window.open(userCenter(`${process.env.SITE_ORIGIN}/pro/user-center?do=mynotice`).login, '_blank');
          return;
        }
        window.open(`/pro/user-center?do=mynotice&uid=${account?.id}&uuid=${account?.uuid}`, 'self');
      }
    },
  ];

  // 复用CommonHeader的发帖逻辑
  const addPost = () => {
    if (permission?.status !== PromiseState.PENDING) {
      if (permission?.code === errorCode.UNBIND_PHONE) {
        // 未绑定手机号
        Toast.show({
          content: permission?.message || t('phone_number_is_not_bound_tip'),
        });
        track?.(TRACK_EVENTS?.[namespace.home].uploadButtonsClick.name, {
          position: 'Bottom',
          is_success: false,
          fail_reason: '未绑定手机号',
        }, namespace.home);
        setTimeout(() => {
          window.open(`${process.env.SITE_ORIGIN}${pagePathUrl.edit}`, "_blank");
        }, 1e3)
      } else {
        // 成功/未登录
        track?.(TRACK_EVENTS?.[namespace.home].uploadButtonsClick.name, {
          position: 'Bottom',
          is_success: !isLogout,
          fail_reason: isLogout ? '未登录' : null,
        }, namespace.home);
        window.open(`${process.env.SITE_ORIGIN}${pagePathUrl.edit}`, "_blank");
      }
    }
  }

  if (!hadLoginState) {
    return (
      <LeftColumnSkeleton />
    )
  }

  return (
    <aside className={styles.sidebar}>
      {/* <SideItems options={HOME_SIDEBAR_NAV_OPTIONS} /> */}
      <SideItems options={HOME_SIDEBAR_LIST_OPTIONS} />
      <div className={styles.homeSideBtn}>
        <Button
          text='发帖'
          icon={<AddPost />}
          onClick={addPost}
          className={styles.addPostButton}
        />
        {/* 登录后隐藏 */}
        {isLogout && (
          <Button
            text='登录'
            icon={<LoginIcon />}
            onClick={() => {
              track?.(TRACK_EVENTS?.[namespace.home].loginButtonClick.name, {
                position: 'Bottom'
              }, namespace.home);
              window.open(userCenter().login, '_blank');
            }}
            className={styles.loginButton}
          />
        )}
      </div>
      {/* 登录后隐藏 */}
      {isLogout && <LoginTips title='登录社区，发现更多精彩' options={HOME_SIDEBAR_LOGIN_TIPS_OPTIONS} />}
      <SideBarFootor />
    </aside>
  );
}

export default Sidebar;